import React from "react";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import mainImage from "../assets/main.png";

const DashboardCard = ({ onExitStart }) => {
  const navigate = useNavigate();

  const handleDashboardClick = () => {
    if (onExitStart) {
      onExitStart();
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div
      className="bg-gray-900 text-white rounded-3xl h-full overflow-hidden cursor-pointer relative"
      onClick={handleDashboardClick}
    >
      {/* 이미지 컨테이너 - 모바일 최적화 */}
      <div className="absolute inset-0 z-0">
        {/* 이미지를 컨테이너에 고정시키고, 화면 크기에 따라 다르게 처리 */}
        <div className="w-full h-full relative overflow-hidden">
          <img
            src={mainImage}
            alt="Dashboard background"
            className="absolute w-full h-full object-cover"
            style={{
              // 모바일에서는 이미지 중앙을 보여주고, 필요에 따라 확대
              objectPosition: "center center",
              transform: "scale(1.2)",
            }}
          />
        </div>
      </div>

      {/* 반투명 오버레이 - 투명도 높임 */}
      <div className="absolute inset-0 bg-gray-900 opacity-75 z-10"></div>

      {/* 콘텐츠 */}
      <div className="relative z-20 flex flex-col justify-between h-full p-6 md:p-8">
        {/* 데스크톱 레이아웃 */}
        <div className="hidden lg:block">
          <h3 style={{ fontSize: "14px" }} className="mb-2 md:mb-4">
            MORE OFFERS
          </h3>
          <div className="text-white leading-snug">
            <h2 className="text-white mb-4">
              <span style={{ fontSize: "80px" }}>One</span>{" "}
              <span style={{ fontSize: "60px" }}>dashboard,</span>
            </h2>
            <h2 className="text-white mb-4">
              <span style={{ fontSize: "80px" }}>All</span>{" "}
              <span style={{ fontSize: "60px" }}>your FX trading data</span>
            </h2>
          </div>
        </div>

        {/* 모바일 레이아웃 */}
        <div className="lg:hidden flex flex-col justify-center items-center h-full">
          <h2 className="text-white text-3xl font-bold text-center mb-2">
            FX Dashboard
          </h2>
          <p className="text-white text-center text-sm opacity-80">
            All your FX trading data in one place
          </p>
        </div>

        {/* 버튼 */}
        <div className="flex items-end justify-center lg:justify-start">
          <button className="bg-white text-black px-8 py-2 md:px-10 md:py-3 rounded-full flex items-center text-lg md:text-xl font-semibold transition-all duration-300 ease-in-out shadow-lg hover:bg-gray-200 hover:shadow-xl">
            Dashboard
            <ChevronRight className="ml-5 w-6 h-7 md:w-7 md:h-7" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;
